exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Pacifico);", ""]);

// module
exports.push([module.id, "@media only screen and (max-width: 375px) {\n  .ant-layout-header {\n    padding: 0 15px !important;\n  }\n}\n.header-logo {\n  font-family: 'Pacifico', cursive;\n  font-size: 2.5em;\n  color: #444444;\n  float: left;\n}\n@media only screen and (max-width: 375px) {\n  .header-logo {\n    margin-top: 5px;\n    font-size: 1.5em;\n  }\n}\n.menu .ant-menu {\n  line-height: 62px;\n  border-bottom: none;\n  float: right;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#cc0000","@layout-body-background":"#cc0000","@layout-header-background":"white"}}!./src/components/header/styles.less
// module id = 1489
// module chunks = 0